import React from 'react';
import clsx from 'clsx';
import BlockTitleGroup from '../block-title-group';
import {useStyles} from './helpers';

const BlockAutoCloseBonus = ({formik}) => {
    const classes = useStyles();

    const [autoCloseBonus, setAutoCloseBonus] = React.useState(false);
    
    return (
        <div>
            <BlockTitleGroup setShowBlock={setAutoCloseBonus} showBlock={autoCloseBonus} title="Автоматическое закрытие бонуса при низком балансе" />
            {
                autoCloseBonus &&
                <>
                    <label htmlFor="min_balance_close_bonus" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Нижняя граница баланса для автоматического закрытия</span>
                        <input 
                            type="number" 
                            name="min_balance_close_bonus" 
                            id="min_balance_close_bonus" 
                            className={classes.text}
                            value={formik.values.min_balance_close_bonus} 
                            onChange={(v) => formik.setFieldValue('min_balance_close_bonus', v.target.value)}
                        />
                    </label>
                </>
            }
        </div>
    )
}

export default BlockAutoCloseBonus;